/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module RiseTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface RisePlugin {
    [k: string]: any;
}
/**
 * Enumerated mic device info
 *
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqMicDeviceInfo".
 */
export interface VqMicDeviceInfo {
    /**
     * Mic device index from system mic enumeration
     */
    index?: number;
    /**
     * Mic device name from system mic enumeration
     */
    micId?: string;
    /**
     * Mic device state from system mic enumeration
     */
    micState?: number;
    /**
     * True if mice is currently a system default mic. False otherwise
     */
    isSystemDefault?: boolean;
}
/**
 * Voice Query  supported language info
 *
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqLanguageInfo".
 */
export interface VqLanguageInfo {
    /**
     * Language name
     */
    name?: string;
    /**
     * True if language supported for ASR text output. False otherwise.
     */
    bASRTextSupport?: boolean;
    /**
     * True if language supported for ASR voice input. False otherwise.
     */
    bASRVoiceSupport?: boolean;
    /**
     * True if language supported for TTS text input. False otherwise.
     */
    bTTSTextSupport?: boolean;
    /**
     * True if language supported for TTS voice output. False otherwise.
     */
    bTTSVoiceSupport?: boolean;
}
/**
 * Voice Query  supported voice character info
 *
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqVoiceCharacterInfo".
 */
export interface VqVoiceCharacterInfo {
    /**
     * Voice character name
     */
    name?: string;
    /**
     * FALSE - Male Voice character. TRUE - Female Voice character
     */
    bFemale?: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseSupportedReturn".
 */
export interface RiseSupportedReturn {
    /**
     * True if supported/installed, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseRequestCompletionParameters".
 */
export interface RiseRequestCompletionParameters {
    /**
     * Request typed or spoken by the user
     */
    content: string;
    contentType: ContentType;
    /**
     * True if thinking mode is ON, false otherwise.
     */
    isThinkingModeOn?: boolean;
    /**
     * json string of NvApp settings and their current values
     */
    nvAppSettings: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseRequestCompletionReturn".
 */
export interface RiseRequestCompletionReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseRegisterParameters".
 */
export interface RiseRegisterParameters {
    /**
     * True to register, false otherwise
     */
    enable: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseRegisterReturn".
 */
export interface RiseRegisterReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseGameNotificationParameters".
 */
export interface RiseGameNotificationParameters {
    /**
     * True for game launch, false for exit
     */
    bLaunched: boolean;
    /**
     * Title of the game
     */
    gameName: string;
    /**
     * Full executable path of the game
     */
    exePath: string;
    /**
     * Process ID of the game
     */
    pid: number;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseGameNotificationReturn".
 */
export interface RiseGameNotificationReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "RiseUpdatesNotificationsReturn".
 */
export interface RiseUpdatesNotificationsReturn {
    /**
     * Latest tokens obtained.
     */
    resultTokens?: string;
    contentType?: ContentType1;
    /**
     * Confirms completion of message of type contentType
     */
    completed?: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "SaveCSVParameters".
 */
export interface SaveCSVParameters {
    /**
     * CSV data to be saved
     */
    csvData: string;
    /**
     * Path of the user's UGC folder
     */
    ugcFolderPath: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "SaveCSVReturn".
 */
export interface SaveCSVReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
    /**
     * GAssist folder path where chart data is saved.
     */
    folderPath: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqVoiceQuerySupportedReturn".
 */
export interface VqVoiceQuerySupportedReturn {
    /**
     * True if supported/installed, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqResisterVoiceQueryParameters".
 */
export interface VqResisterVoiceQueryParameters {
    /**
     * True to create, false to destroy voice query session
     */
    create: boolean;
    /**
     * True to use RISE ASR, false to use legacy Voice Query API (default: false)
     */
    useRiseAsr?: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqResisterVoiceQueryReturn".
 */
export interface VqResisterVoiceQueryReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqVoiceQueryResultNotficationReturn".
 */
export interface VqVoiceQueryResultNotficationReturn {
    /**
     * Text output from ASR.
     */
    queryText?: string;
    /**
     * Voice Query result HRESULT error code
     */
    queryResultCode?: number;
    responseType?: ResponseType;
    /**
     * Indicates if this is the final ASR result
     */
    isFinal?: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqMicDeviceChangedNotificationReturn".
 */
export interface VqMicDeviceChangedNotificationReturn {
    /**
     * True  if mic device plugged in. False if unplugged
     */
    bConnected?: boolean;
    /**
     * Mic device index in the system enumeration
     */
    index?: number;
    /**
     * Mic device id
     */
    micId?: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqSetVoiceQueryParameters".
 */
export interface VqSetVoiceQueryParameters {
    vqMode: VqMode;
    /**
     * Microphone source. If empty, system default mic to be used
     */
    micId: string;
    /**
     * Voice language id. Keep empty for auto detect
     */
    voiceLangId: string;
    /**
     * Text language. if empty, default would be english
     */
    textLangId: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqSetVoiceQueryReturn".
 */
export interface VqSetVoiceQueryReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqSetVoicePlaybackParameters".
 */
export interface VqSetVoicePlaybackParameters {
    /**
     * Text language. if empty, default would be english
     */
    textLangId: string;
    /**
     * Voice language id. Keep empty for auto detect
     */
    voiceLangId: string;
    /**
     * Voice Character id. If empty, system default mic to be used
     */
    voiceCharacterId: string;
    /**
     * Text string to playback as voice
     */
    text: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqSetVoicePlaybackReturn".
 */
export interface VqSetVoicePlaybackReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqEnumMicDevicesReturn".
 */
export interface VqEnumMicDevicesReturn {
    /**
     * Array of enumerated mic devices
     */
    MicDevices: VqMicDeviceInfo[];
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqEnumLanguagesReturn".
 */
export interface VqEnumLanguagesReturn {
    /**
     * Array of enumerated mic devices
     */
    Languages: VqLanguageInfo[];
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqEnumVoiceCharactersReturn".
 */
export interface VqEnumVoiceCharactersReturn {
    /**
     * Array of enumerated voice characters
     */
    Characters: VqVoiceCharacterInfo[];
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqPrepareMicParameters".
 */
export interface VqPrepareMicParameters {
    /**
     * Microphone device id to prepare. If empty, system default mic to be used
     */
    micId: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqPrepareMicReturn".
 */
export interface VqPrepareMicReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqTeardownMicParameters".
 */
export interface VqTeardownMicParameters {
    /**
     * Microphone device id to teardown. If empty, system default mic to be used
     */
    micId: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "VqTeardownMicReturn".
 */
export interface VqTeardownMicReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistSupportedReturn".
 */
export interface GameAssistSupportedReturn {
    /**
     * True if supported/installed, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistCreateSessionParameters".
 */
export interface GameAssistCreateSessionParameters {
    /**
     * True to create, false to destroy game assist session
     */
    create: boolean;
    /**
     * Title of the game
     */
    gameName: string;
    /**
     * Process ID of the game
     */
    pid: number;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistCreateSessionReturn".
 */
export interface GameAssistCreateSessionReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistQueryResponseNotficationReturn".
 */
export interface GameAssistQueryResponseNotficationReturn {
    /**
     * Response text from Game Assist.
     */
    responseText?: string;
    /**
     * Query result HRESULT error code
     */
    queryResultCode?: number;
    responseType?: ResponseType1;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistSubmitQueryParameters".
 */
export interface GameAssistSubmitQueryParameters {
    /**
     * User prompt text for game assist
     */
    queryText: string;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "GameAssistSubmitQueryReturn".
 */
export interface GameAssistSubmitQueryReturn {
    /**
     * True if the request has been performed successfully, false otherwise.
     */
    status: boolean;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "EnsureNvAppReadyForGAssistParameters".
 */
export interface EnsureNvAppReadyForGAssistParameters {
    /**
     * Launch NVIDIA App if not already running
     */
    launchIfNotReady: boolean;
    /**
     * Timeout in milliseconds to wait for NVIDIA App to be ready
     */
    timeoutMs: number;
}
/**
 * This interface was referenced by `RisePlugin`'s JSON-Schema
 * via the `definition` "EnsureNvAppReadyForGAssistReturn".
 */
export interface EnsureNvAppReadyForGAssistReturn {
    /**
     * True if NvApp is ready, false if timeout or error
     */
    status: boolean;
    /**
     * Error message if status is false
     */
    errorMessage?: string;
    /**
     * True if NvApp was already launched, false otherwise
     */
    wasAlreadyLaunched: boolean;
}

/**
 * Type of message
 */
export enum ContentType {
    NV_RISE_CONTENT_TYPE_INVALID = 0,
    NV_RISE_CONTENT_TYPE_TEXT = 1,
    NV_RISE_CONTENT_TYPE_GRAPH = 2,
    NV_RISE_CONTENT_TYPE_CUSTOM_BEHAVIOR = 3,
    NV_RISE_CONTENT_TYPE_CUSTOM_BEHAVIOR_RESULT = 4,
    NV_RISE_CONTENT_TYPE_INSTALLING = 5,
    NV_RISE_CONTENT_TYPE_PROGRESS_UPDATE = 6,
    NV_RISE_CONTENT_TYPE_READY = 7,
    NV_RISE_CONTENT_TYPE_DOWNLOAD_REQUEST = 8,
    NV_RISE_CONTENT_TYPE_UPDATE_INFO = 9
}
/**
 * Type of message
 */
export enum ContentType1 {
    NV_RISE_CONTENT_TYPE_INVALID = 0,
    NV_RISE_CONTENT_TYPE_TEXT = 1,
    NV_RISE_CONTENT_TYPE_GRAPH = 2,
    NV_RISE_CONTENT_TYPE_CUSTOM_BEHAVIOR = 3,
    NV_RISE_CONTENT_TYPE_CUSTOM_BEHAVIOR_RESULT = 4,
    NV_RISE_CONTENT_TYPE_INSTALLING = 5,
    NV_RISE_CONTENT_TYPE_PROGRESS_UPDATE = 6,
    NV_RISE_CONTENT_TYPE_READY = 7,
    NV_RISE_CONTENT_TYPE_DOWNLOAD_REQUEST = 8,
    NV_RISE_CONTENT_TYPE_UPDATE_INFO = 9
}
/**
 * Type of result
 */
export enum ResponseType {
    NvVqApi_VoiceQueryResponse_ASRText = 0
}
/**
 * Set Voice Query mode
 */
export enum VqMode {
    NvVqApi_VoiceQueryMode_Start = 0,
    NvVqApi_VoiceQueryMode_Stop = 1,
    NvVqApi_VoiceQueryMode_StartAutoStop = 2,
    NvVqApi_VoiceQueryMode_StartWakeWord = 3,
    NvVqApi_VoiceQueryMode_StopWakeWord = 4
}
/**
 * Type of result: ResponseChunk - Regular text output from the LLM, CitationChunk - Citation/epilog chunk to the original response, Sentinel - Sentinel token (end of response)
 */
export enum ResponseType1 {
    NvGameAssistApi_QueryResponse_ResponseChunk = 0,
    NvGameAssistApi_QueryResponse_CitationChunk = 1,
    NvGameAssistApi_QueryResponse_Sentinel = 2,
    NvGameAssistApi_QueryResponse_GameAssistReady = 3,
    NvGameAssistApi_QueryResponse_Fail = 4,
    NvGameAssistApi_QueryResponse_UnsupportedQuery = 5,
    NvGameAssistApi_QueryResponse_AlertNotification = 6,
    NvGameAssistApi_QueryResponse_ClearOngoingStream = 7,
    NvGameAssistApi_QueryResponse_SpecialMessage = 8
}


}
